/* eslint-disable */

<template>
  <div>
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row" :class="{ 'cursor-drag': draggingCard === true }">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/antenna-right.png" width="20" />
                <span class="ml-2">Parabolic Right</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/antenna-left.png" width="20" />
                <span class="ml-2">Parabolic Left</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/Omnidirectional.png" width="20" />
                <span class="ml-2">Omni Directional</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/directional-right.png" width="20" />
                <span class="ml-2">Directional Right</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/directional-left.png" width="20" />
                <span class="ml-2">Directional Left</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/n-unlock.png" width="20" />
                <span class="ml-2">OPEN</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/n-unlock.png" width="20" />
                <span class="ml-2">OPEN</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/n-unlock.png" width="20" />
                <span class="ml-2">OPEN</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/n-lock.png" width="20" />
                <span class="ml-2">WPA2-CCMP</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer">
                <img src="https://rapidsimulations.com/simulations/2/images/n-lock.png" width="20" />
                <span class="ml-2">WPA2-CCMP</span>
              </h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="vx-row">
              <div class="vx-col w-7/12">
                <div class="border-2 border-solid rounded p-5">
                  <h1 class="mb-3">Building 1</h1>
                  <div class="border border-solid rounded p-1">
                    <vs-collapse-item class="p-0">
                      <div slot="header" class="p-0">
                        <h3 class="font-light">External AP4</h3>
                      </div>
                      <vue-draggable-container
                        class="answerStandard dropzone dropzoneStandard answer-bg mb-4 direction-bg"
                        id="inputEXAP4Dir"
                      />
                      <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg security-bg" id="inputEXAP4Sec" />
                    </vs-collapse-item>
                  </div>
                  <img src="https://rapidsimulations.com/simulations/2/images/New-Office.png" class="responsive my-2" />
                  <div class="grid grid-cols-1 gap-3">
                    <div class="border border-solid rounded p-1">
                      <vs-collapse-item class="p-0">
                        <div slot="header" class="p-0">
                          <h3 class="font-light">AP1</h3>
                        </div>
                        <vue-draggable-container
                          class="answerStandard dropzone dropzoneStandard answer-bg mb-4 direction-bg"
                          id="inputAP1Dir"
                        />
                        <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg security-bg" id="inputAP1Sec" />
                      </vs-collapse-item>
                    </div>
                    <div class="border border-solid rounded p-1">
                      <vs-collapse-item class="p-0">
                        <div slot="header" class="p-0">
                          <h3 class="font-light">AP2</h3>
                        </div>
                        <vue-draggable-container
                          class="answerStandard dropzone dropzoneStandard answer-bg mb-4 direction-bg"
                          id="inputAP2Dir"
                        />
                        <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg security-bg" id="inputAP2Sec" />
                      </vs-collapse-item>
                    </div>
                    <div class="border border-solid rounded p-1">
                      <vs-collapse-item class="p-0">
                        <div slot="header" class="p-0">
                          <h3 class="font-light">AP3</h3>
                        </div>
                        <vue-draggable-container
                          class="answerStandard dropzone dropzoneStandard answer-bg mb-4 direction-bg"
                          id="inputAP3Dir"
                        />
                        <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg security-bg" id="inputAP3Sec" />
                      </vs-collapse-item>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col w-1/12">
                <div class="flex items-center justify-center">
                  <div class="pt-32">
                    <h3 class="w-full mb-2">2500ft</h3>
                    <img
                      class="responsive"
                      src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/279928282151911424/road.png"
                    />
                  </div>
                </div>
              </div>
              <div class="vx-col w-4/12">
                <div class="border-2 border-solid rounded p-5">
                  <h1 class="mb-3">Building 2</h1>
                  <div class="border border-solid rounded p-1">
                    <vs-collapse-item class="p-0">
                      <div slot="header" class="p-0">
                        <h3 class="font-light">External AP2</h3>
                      </div>
                      <vue-draggable-container
                        class="answerStandard dropzone dropzoneStandard answer-bg mb-4 direction-bg"
                        id="inputEXAP2Dir"
                      />
                      <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg security-bg" id="inputEXAP2Sec" />
                    </vs-collapse-item>
                  </div>
                  <img src="https://rapidsimulations.com/simulations/2/images/Small-Office.png" class="responsive my-2" />
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      //last_drag_error: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel();
        }
      }
    },
    /*  drag_error () {
      const now = new Date().getTime()
      if (this.last_drag_error === false || (now - this.last_drag_error) > 7500) {
        this.last_drag_error = now
        this.$vs.notify(
          {
            color: 'warning',
            title: 'Maximum One Answer Per Input',
            position: 'top-center',
            icon: 'feather',
            iconPack: 'icon-alert-circle',
          })
      }
    }, */
    markSimulation() {
      let totalScore = 0;

      if (document.getElementById('inputEXAP4Dir').textContent === 'Parabolic Right') {
        document.getElementById('inputEXAP4Dir').style.borderColor = '#28C76F';
        document.getElementById('inputEXAP4Dir').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('inputEXAP4Dir').style.borderColor = '#fd4445';
        document.getElementById('inputEXAP4Dir').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('inputEXAP4Sec').textContent === 'WPA2-CCMP') {
        document.getElementById('inputEXAP4Sec').style.borderColor = '#28C76F';
        document.getElementById('inputEXAP4Sec').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('inputEXAP4Sec').style.borderColor = '#fd4445';
        document.getElementById('inputEXAP4Sec').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('inputEXAP2Dir').textContent === 'Parabolic Left') {
        document.getElementById('inputEXAP2Dir').style.borderColor = '#28C76F';
        document.getElementById('inputEXAP2Dir').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('inputEXAP2Dir').style.borderColor = '#fd4445';
        document.getElementById('inputEXAP2Dir').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('inputEXAP2Sec').textContent === 'WPA2-CCMP') {
        document.getElementById('inputEXAP2Sec').style.borderColor = '#28C76F';
        document.getElementById('inputEXAP2Sec').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('inputEXAP2Sec').style.borderColor = '#fd4445';
        document.getElementById('inputEXAP2Sec').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('inputAP1Dir').textContent === 'Directional Right') {
        document.getElementById('inputAP1Dir').style.borderColor = '#28C76F';
        document.getElementById('inputAP1Dir').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('inputAP1Dir').style.borderColor = '#fd4445';
        document.getElementById('inputAP1Dir').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('inputAP1Sec').textContent === 'OPEN') {
        document.getElementById('inputAP1Sec').style.borderColor = '#28C76F';
        document.getElementById('inputAP1Sec').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('inputAP1Sec').style.borderColor = '#fd4445';
        document.getElementById('inputAP1Sec').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('inputAp2Dir').textContent === 'Omnidirectional') {
        document.getElementById('inputAp2Dir').style.borderColor = '#28C76F';
        document.getElementById('inputAp2Dir').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('inputAp2Dir').style.borderColor = '#fd4445';
        document.getElementById('inputAp2Dir').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('inputAp2Sec').textContent === 'OPEN') {
        document.getElementById('inputAp2Sec').style.borderColor = '#28C76F';
        document.getElementById('inputAp2Sec').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('inputAp2Sec').style.borderColor = '#fd4445';
        document.getElementById('inputAp2Sec').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('inputAP3Dir').textContent === 'Directional Left') {
        document.getElementById('inputAP3Dir').style.borderColor = '#28C76F';
        document.getElementById('inputAP3Dir').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('inputAP3Dir').style.borderColor = '#fd4445';
        document.getElementById('inputAP3Dir').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('inputAP3Sec').textContent === 'OPEN') {
        document.getElementById('inputAP3Sec').style.borderColor = '#28C76F';
        document.getElementById('inputAP3Sec').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('inputAP3Sec').style.borderColor = '#fd4445';
        document.getElementById('inputAP3Sec').style.backgroundColor = '#fd4445';
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.direction-bg {
  height: 55px;
  margin-top: 5px;
  margin-bottom: 5px;
  background-image: url('https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/279928282151911424/antenna.png');
  background-position: 0px 0px, 0% 50%;
  background-size: 60px, 60px;
  background-repeat: repeat, no-repeat;
}

.security-bg {
  height: 50px;
  margin-top: 5px;
  margin-bottom: 5px;
  background-image: url('https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/279928282151911424/lock.png');
  background-position: 0px 0px, 0% 50%;
  background-size: 60px, 60px;
  background-repeat: repeat, no-repeat;
}
</style>
